import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as jspreadsheet from 'jspreadsheet-ce';
import { ForecastWeekEditable } from '../services/forecast-week-editable.service';
import { CampaignUpdate } from '../week/forecast-week/CampaignUpdate';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-history',
	templateUrl: './history.component.html',
	styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements AfterViewInit {
	@ViewChild('sheet', { static: true }) sheet: ElementRef;

	private campaingUpdate: CampaignUpdate = new CampaignUpdate(0, 0, 0);
	campaignList: any = [];
	campaignTypeList: any = [];
	campaignPeriods: any = [];
	isHidden: boolean = false;
	public selectedCampaign: number;
	public selectedTypeCampaign: string;
	keyword = 'name';
	isSearch: boolean = false;
	fechas: any;
	days: any;
	monday_1: any;
	monday_2: any;
	monday_3: any;
	monday_4: any;
	monday_5: any;
	monday_6: any;
	monday_7: any;
	monday_8: any;

	constructor(private forecastWeekEditable: ForecastWeekEditable) {}

	ngAfterViewInit() {
		this.monday_8 = getPastMonday(new Date(), 7).toDateString().slice(4);
		this.monday_7 = getPastMonday(new Date(), 14).toDateString().slice(4);
		this.monday_6 = getPastMonday(new Date(), 21).toDateString().slice(4);
		this.monday_5 = getPastMonday(new Date(), 28).toDateString().slice(4);
		this.monday_4 = getPastMonday(new Date(), 35).toDateString().slice(4);
		this.monday_3 = getPastMonday(new Date(), 42).toDateString().slice(4);
		this.monday_2 = getPastMonday(new Date(), 49).toDateString().slice(4);
		this.monday_1 = getPastMonday(new Date(), 56).toDateString().slice(4);

		var promise = Promise.resolve(
			this.forecastWeekEditable.getForecastLeadsByDate(),
		);
		promise.then((value) => {
			var changed = (
				instance: any,
				cell: any,
				x: any,
				y: any,
				value: any,
			) => {
				var cellName = jspreadsheet.getColumnNameFromId([x, y]);
				var rowInt = parseInt(y) + 1;

				var campaignId = tableWeek.getLabel('B' + rowInt);
				var leadsAssigned = value;
				var getDays = x;

				if (x == 5) {
					this.days = 56;
				}
				if (x == 7) {
					this.days = 49;
				}
				if (x == 9) {
					this.days = 42;
				}
				if (x == 11) {
					this.days = 35;
				}
				if (x == 13) {
					this.days = 28;
				}
				if (x == 15) {
					this.days = 21;
				}
				if (x == 17) {
					this.days = 14;
				}
				if (x == 19) {
					this.days = 7;
				}

				if (x > 4 && x < 21) {
					// tableWeek.resetStyle(cellName);
					if (value == 0) {
						tableWeek.setStyle(
							cellName,
							'background-color',
							'#ffbcb8',
						);
					} else {
						tableWeek.setStyle(
							cellName,
							'background-color',
							'#e2ffc9',
						);
					}
					//  tableWeek.setStyle('B'+rowInt, 'background-color' , '#000000');

					var getDate = getPastMonday(new Date(), this.days);
					var date = formatDate(getDate);
					this.campaingUpdate = new CampaignUpdate(
						campaignId,
						leadsAssigned,
						date,
					);
					Promise.resolve(
						this.forecastWeekEditable.updateWeekForecast(
							this.campaingUpdate,
						),
					);
				}
			};

			var tableWeek = jspreadsheet(this.sheet.nativeElement, {
				data: value.body,
				csvHeaders: true,
				search: true,
				pagination: 100,
				tableOverflow: true,
				freezeColumns: 3,
				tableWidth: '1100px',
				tableHeight: '1100px',
				columns: [
					{ title: 'Row', width: 80, type: 'hidden', readOnly: true },
					{
						title: 'Campaign ID',
						width: 80,
						type: 'hidden',
						readOnly: true,
					},
					{ title: 'Campaign', width: 100, readOnly: true },
					{ title: 'Industry', width: 100, readOnly: true },
					{
						title: 'Lead Cost',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Leads',
						width: 70,
						type: 'numeric',
						readOnly: true,
					},
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{
						title: 'Leads',
						width: 70,
						type: 'numeric',
						readOnly: true,
					},
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{
						title: 'Leads',
						width: 70,
						type: 'numeric',
						readOnly: true,
					},
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{
						title: 'Leads',
						width: 70,
						type: 'numeric',
						readOnly: true,
					},
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{
						title: 'Leads',
						width: 70,
						type: 'numeric',
						readOnly: true,
					},
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{
						title: 'Leads',
						width: 70,
						type: 'numeric',
						readOnly: true,
					},
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{
						title: 'Leads',
						width: 70,
						type: 'numeric',
						readOnly: true,
					},
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{
						title: 'Leads',
						width: 70,
						type: 'numeric',
						readOnly: true,
					},
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, readOnly: true },
					{
						title: 'Income',
						width: 100,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
				],
				footers: [
					[
						'',
						'',
						'',
						'',
						'Total',
						'=ROUND(SUM(F1:F300),2)',
						'',
						'=ROUND(SUM(H1:H300),2)',
						'',
						'=ROUND(SUM(J1:J300),2)',
						'',
						'=ROUND(SUM(L1:L300),2)',
						'',
						'=ROUND(SUM(N1:N300),2)',
						'',
						'=ROUND(SUM(P1:P300),2)',
						'',
						'=ROUND(SUM(R1:R300),2)',
						'',
						'=ROUND(SUM(T1:T300),2)',
						'',
						'=ROUND(SUM(V1:V300),2)',
						'=ROUND(SUM(W1:W300),2)',
					],
				],
				onchange: changed,
				nestedHeaders: [
					[
						{
							title: 'Campaign Info',
							colspan: 3,
						},
						{
							title: this.monday_1,
						},
						{
							title: this.monday_2,
						},
						{
							title: this.monday_3,
						},
						{
							title: this.monday_4,
						},
						{
							title: this.monday_5,
						},
						{
							title: this.monday_6,
						},
						{
							title: this.monday_7,
						},
						{
							title: this.monday_8,
						},
						{
							title: 'Totals',
							colspan: 2,
						},
					],
				],
				updateTable: function (
					instance,
					cell,
					col,
					row,
					val,
					label,
					cellName,
				) {
					if (
						col == 5 ||
						col == 7 ||
						col == 9 ||
						col == 11 ||
						col == 13 ||
						col == 15 ||
						col == 17 ||
						col == 19
					) {
						for (var i = 1; i < 150; i++) {
							var valueG = instance.jexcel.getValue('G' + i);

							if (cellName == 'F' + i && valueG == 0) {
								cell.style.backgroundColor = '#f1dcfc';
							}
							if (cellName == 'F' + i && valueG > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueI = instance.jexcel.getValue('I' + i);
							if (cellName == 'H' + i && valueI == 0) {
								cell.style.backgroundColor = '#f1dcfc';
							}
							if (cellName == 'H' + i && valueI > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueK = instance.jexcel.getValue('K' + i);
							if (cellName == 'J' + i && valueK == 0) {
								cell.style.backgroundColor = '#f1dcfc';
							}
							if (cellName == 'J' + i && valueK > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueM = instance.jexcel.getValue('M' + i);
							if (cellName == 'L' + i && valueM == 0) {
								cell.style.backgroundColor = '#f1dcfc';
							}
							if (cellName == 'L' + i && valueM > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueO = instance.jexcel.getValue('O' + i);
							if (cellName == 'N' + i && valueO == 0) {
								cell.style.backgroundColor = '#f1dcfc';
							}
							if (cellName == 'N' + i && valueO > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueQ = instance.jexcel.getValue('Q' + i);
							if (cellName == 'P' + i && valueQ == 0) {
								cell.style.backgroundColor = '#f1dcfc';
							}
							if (cellName == 'P' + i && valueQ > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueS = instance.jexcel.getValue('S' + i);
							if (cellName == 'R' + i && valueS == 0) {
								cell.style.backgroundColor = '#f1dcfc';
							}
							if (cellName == 'R' + i && valueS > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueU = instance.jexcel.getValue('U' + i);
							if (cellName == 'T' + i && valueU == 0) {
								cell.style.backgroundColor = '#f1dcfc';
							}
							if (cellName == 'T' + i && valueU > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}
						}
					}

					if (col > 4 && col < 21) {
						if (val <= 0) {
							cell.style.backgroundColor = '#fcd7d8';
						}
					}
				},
			});
		});
	}

	selectEventCampaign(item: any) {
		this.selectedCampaign = item.id;
	}

	search_weeks(event: any) {}
}

// function getPastMonday(date = new Date(),int: number) {
// 	const dateCopy = new Date(date.getTime());

// 	const nextMonday = new Date(
// 		dateCopy.setDate(
// 		  dateCopy.getDate() + ((int - dateCopy.getDay() + 1) % int || int),
// 		),
// 	);

// 	return nextMonday;
// }

function getPastMonday(date = new Date(), int: number) {
	// var date = new Date();
	var day = date.getDay();
	var prevMonday = new Date();
	if (date.getDay() == 0) {
		prevMonday.setDate(date.getDate() - 14);
	} else {
		prevMonday.setDate(date.getDate() - (day + int - 1));
	}

	return prevMonday;
}

function formatDate(fecha: any) {
	var d = new Date(fecha),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	return [year, month, day].join('-');
}
